/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, {Component} from 'react';
// material
import Page from 'material/structure/page/page';
import Subhead from 'material/structure/subhead/subhead';
import Content from 'material/structure/content/content';
import Group from 'material/group/group';
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import EditInfoCTA from 'material/ctas/editinfo/editinfo_container';
import Form from 'material/form/form_container';
import Field from 'material/form/field/field_container';
import Grid from 'material/grid/grid';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
// utils
import { log } from 'utils/logger';
// styles
import styles from 'pages/dashboard/myprofile/myprofile_styles';
import injectSheet from 'react-jss';




/* ========== ~~~~~~~~~~ PAGE : REQUEST DEMO : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class MyProfile extends Component {
    constructor(props){
        super(props);
        this.formName = 'personalInformationForm';
    }
    componentDidMount() {
        // Populates form data with the data from session status.
        // The data will be stored in session status if user logs in by clicking on log in button
        // In that case session status is pupulated with the auth data before the component mounts
        this.props.receiveFormData(this.formName, this.getFormCallData(false))
    }
    componentDidUpdate(prevProps) {
        if (prevProps.userEmail !== this.props.userEmail) this.props.receiveFormData(this.formName, this.getFormCallData(false))
    }
    handleSave = () => {
        this.props.updateUserInfoWithValidation(this.props.fields, this.getFormCallData(), this.props.userUUID, this.processSuccessfulUpdate, this.processFailedUpdate)
    };
    processSuccessfulUpdate = response => {
        log('UPDATED RESPONSE. SUCCESS:', response.data)
        this.props.setAuthData(response)
    };
    processFailedUpdate = errorResponse => {
        log('UPDATED RESPONSE. FAIL:', errorResponse)
    };

    getFormCallData = (isFormData=true) => ({
        firstName: isFormData ? this.props.fields.fname.value : this.props.userFirstName,
        lastName: isFormData ? this.props.fields.lname.value : this.props.userLastName,
        email: isFormData ? this.props.fields.email.value: this.props.userEmail,
        phoneNumber: isFormData ? this.props.fields.phone.value: this.props.userPhoneNumber,
    });

    componentWillUnmount() {
        this.props.resetForm(this.formName)
    }
    render() {
        const { fname, lname, phone, email, } = this.props.fields;
        return(
            <Page name={`myprofile`} klass={this.props.classes.myprofile}>
                <Form name={`personalInformationForm`} editable={this.props.editable} processing={this.props.savingData}>
                    <Subhead>
                        <h1>My Profile</h1>
                    </Subhead>
                    <Content>
                        <Copy name={`page-copy`}>
                            <Title variant={'withctas'}>
                                <h2>Personal Information</h2>
                                {this.props.mocked ? null : <EditInfoCTA formName={this.formName}
                                             editable={this.props.editable}
                                             savingData={this.props.savingData}
                                             saveFormData={this.handleSave}
                                />}
                            </Title>
                        </Copy>
                        <Group name={`page-details`}>
                            <Grid type={`fields`}>
                                <GridSet direction={`horizontal`}>
                                    <GridItem><Field type={`text`} formName={this.formName} name={`fname`} placeholder={`First Name`} label={`First Name`} info={``} value={fname.value} valid={fname.valid} disabled={this.props.mocked} required /></GridItem>
                                    <GridItem><Field type={`text`} formName={this.formName} name={`lname`} placeholder={`Last Name`} label={`Last Name`} info={``} value={lname.value} valid={lname.valid} disabled={this.props.mocked} required /></GridItem>
                                </GridSet>
                                <GridSet direction={`horizontal`}>
                                    <GridItem><Field type={`text`} formName={this.formName} name={`email`} placeholder={`Email`} label={`Email`} info={``} value={email.value} valid={email.valid} disabled={true} required /></GridItem>
                                </GridSet>
                                <GridSet>
                                    <GridItem><Field type={`text`} formName={this.formName} name={`phone`} placeholder={`Phone Number`} label={`Phone Number`} info={``} value={phone.value} valid={phone.valid} disabled={this.props.mocked} required /></GridItem>
                                </GridSet>
                            </Grid>
                        </Group>
                    </Content>
                </Form>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(MyProfile);